module.exports = "https://cdn.realtymogul.com/static/media/Chris_F.e750f87f.jpg";